/* BB color tap — medición del A/B de colores (X02) y estampado de las cohortes.
 *
 * Qué mide y por qué:
 *   · bb_sw_view_a|b — una vez por ficha con 2 o más colores. Es el DENOMINADOR
 *     del A/B: sin él, «toques por sesión» no se puede comparar entre brazos.
 *   · bb_color_tap   — cada vez que el cliente toca un color. Lleva cuánta foto
 *     estaba viendo en ese momento (foto_visible) y si subió a mirarla después
 *     (subio_a_foto). Esos dos números son la pregunta que abrió Cristóbal el
 *     22-sep: «los colores, cuando el usuario escoge, ¿cómo es su experiencia?».
 *
 * subio_a_foto no se puede saber en el instante del toque, así que el evento se
 * manda 2,5 s después y en ese rato se vigila si la foto llegó a verse al 80 %.
 * Si el cliente se va antes (pagehide / pestaña oculta), se manda lo que haya.
 *
 * También estampa las cohortes en el carro (atributos bb_sp_cohorte y
 * bb_sw_cohorte) al agregar al carro, una sola vez por página. En las fichas de
 * lectura el estampado lo sigue haciendo el módulo del 2.º par: acá se salta,
 * para no tocar ese archivo (A/B en curso hasta el 11-nov) ni mandar dos POST.
 *
 * No toca el formulario, ni los inputs, ni los precios: solo escucha.
 */
(function () {
  'use strict';
  if (window.__bbColorTap) return;
  window.__bbColorTap = true;

  var ESPERA = 2500; /* ms que se vigila «¿subió a la foto?» tras el toque */

  function init() {
    var info = window.bbCohorte || {};
    var preview = !!info.preview;

    var seccion = document.querySelector('[data-bb-ficha-v2]');
    /* Cuál es «el selector de color» de esta ficha.
       Desde el 24-sep hay fichas con carrusel de COMBINACIONES (marco + cristal,
       `[data-bb-combos]`): ahí el selector es ese, y los dos fieldsets originales
       están escondidos por CSS. Se prefiere solo si de verdad se ve: en el brazo a
       el de combinaciones está en display:none y el selector sigue siendo el de
       hoy, así que la medición del brazo a no cambia ni un dato. */
    var fieldset = (function () {
      var combos = document.querySelector('fieldset[data-bb-combos]');
      if (combos && combos.getClientRects().length > 0) return combos;
      var sets = document.querySelectorAll('fieldset.variant-input-wrap');
      for (var i = 0; i < sets.length; i++) {
        var h = sets[i].getAttribute('data-handle') || '';
        if (h.indexOf('color') === 0) return sets[i];
      }
      return null;
    })();

    /* --- envío: igual que bb-segundo-par.js (gtag, si no dataLayer), y nunca
       si el visitante no aceptó analítica. En vista previa del theme no se
       manda nada a GA4: se deja en window.__bbEventos para poder verificarlo. */
    var registro = (window.__bbEventos = window.__bbEventos || []);
    function track(nombre, params) {
      params = params || {};
      registro.push({ n: nombre, p: params, t: Date.now() });
      if (preview) return;
      var privacy = window.Shopify && Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;
      try {
        if (typeof window.gtag === 'function') window.gtag('event', nombre, params);
        else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: nombre }, params));
      } catch (e) {}
    }

    /* --- cuánta foto principal se ve, en % de su alto --- */
    var foto = document.querySelector('.product__main-photos') ||
               document.querySelector('.product__photos');
    function visibleFoto() {
      if (!foto) return 0;
      var r = foto.getBoundingClientRect();
      if (!r.height) return 0;
      var alto = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
      return Math.round(alto / r.height * 100);
    }

    /* --- estampado de cohortes en el carro (una vez por página) --- */
    var moduloLectura = document.querySelector('[data-bb-sp][data-modo="ab"]');
    var estampado = false;
    function estampar() {
      if (estampado || preview || moduloLectura) return;
      var attrs = {};
      if (info.sp) attrs.bb_sp_cohorte = info.sp;
      if (info.sw) attrs.bb_sw_cohorte = info.sw;
      if (!attrs.bb_sp_cohorte && !attrs.bb_sw_cohorte) return;
      estampado = true;
      var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(raiz + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () { estampado = false; });
    }
    document.addEventListener('ajaxProduct:added', estampar);

    /* Carrusel de escritorio (24-sep): al cargar y al cambiar de color, la
       tarjeta elegida se trae a la vista dentro de la fila, sin mover la
       página (scrollLeft del fieldset, no scrollIntoView). Solo brazo b. */
    function asomarElegido() {
      if (!fieldset || !document.documentElement.classList.contains('bb-sw-b')) return;
      var input = fieldset.querySelector('input:checked');
      var cell = input && input.closest('.variant-input');
      if (!cell) return;
      var izq = cell.offsetLeft, der = izq + cell.offsetWidth;
      if (izq < fieldset.scrollLeft) fieldset.scrollLeft = izq;
      else if (der > fieldset.scrollLeft + fieldset.clientWidth) fieldset.scrollLeft = der - fieldset.clientWidth;
    }
    /* bb-combos.js la llama cuando sincroniza la tarjeta sin `change` propio. */
    window.__bbAsomarColor = asomarElegido;
    if (fieldset) {
      asomarElegido();
      fieldset.addEventListener('change', function () { setTimeout(asomarElegido, 50); });
    }

    /* Barrita de posición (24-sep): el pulgar mide la parte visible y se mueve
       con el scroll; arrastrarlo (o tocar la pista) mueve el carrusel. Solo
       existe donde el CSS la muestra (escritorio, brazo b): si no hay desborde,
       se esconde. */
    var barra = fieldset && fieldset.parentElement && fieldset.parentElement.querySelector('[data-bb-sw-barra]');
    if (barra) {
      var pulgar = barra.firstElementChild;
      function pintarBarra() {
        var total = fieldset.scrollWidth, ver = fieldset.clientWidth;
        if (!total || total <= ver + 2 || barra.offsetParent === null) { barra.hidden = true; return; }
        barra.hidden = false;
        var w = Math.max(ver / total, 0.12);
        var x = (fieldset.scrollLeft / (total - ver)) * (1 - w);
        pulgar.style.width = (w * 100) + '%';
        pulgar.style.left = (x * 100) + '%';
      }
      pintarBarra();
      fieldset.addEventListener('scroll', pintarBarra, { passive: true });
      window.addEventListener('resize', pintarBarra);
      var arrastrando = false, x0 = 0, s0 = 0;
      function mover(ev) {
        if (!arrastrando) return;
        var total = fieldset.scrollWidth, ver = fieldset.clientWidth;
        fieldset.scrollLeft = s0 + (ev.clientX - x0) * (total / barra.clientWidth);
      }
      barra.addEventListener('pointerdown', function (ev) {
        var r = barra.getBoundingClientRect(), pr = pulgar.getBoundingClientRect();
        if (ev.clientX < pr.left || ev.clientX > pr.right) {
          var total = fieldset.scrollWidth, ver = fieldset.clientWidth;
          fieldset.scrollLeft = ((ev.clientX - r.left) / r.width) * total - ver / 2;
        }
        arrastrando = true; x0 = ev.clientX; s0 = fieldset.scrollLeft;
        barra.setPointerCapture(ev.pointerId); ev.preventDefault();
      });
      barra.addEventListener('pointermove', mover);
      barra.addEventListener('pointerup', function () { arrastrando = false; });
      barra.addEventListener('pointercancel', function () { arrastrando = false; });
    }

    if (!info.medir || !fieldset) return;

    function visibles() {
      return Array.prototype.filter.call(fieldset.querySelectorAll('.variant-input'), function (e) {
        return e.getClientRects().length > 0;
      });
    }

    var colores = visibles().length || info.colores || 0;
    var plantilla = info.plantilla || '';
    var cohorte = info.sw || '';

    if (colores >= 2 && cohorte) track('bb_sw_view_' + cohorte, { plantilla: plantilla, colores: colores });

    /* --- el toque --- */
    var pendientes = [];
    function mandar(p) {
      if (p.enviado) return;
      p.enviado = true;
      clearTimeout(p.timer);
      track('bb_color_tap', {
        plantilla: plantilla,
        pos: p.pos,
        colores: p.colores,
        foto_visible: p.foto,
        subio_a_foto: p.subio ? 1 : 0,
        cohorte_sw: cohorte
      });
    }

    /* Un toque en el swatch llega DOS veces: el navegador despacha el clic en
       el <label> y después lo reenvía al radio asociado, y los dos burbujean
       hasta el fieldset. Sin este filtro cada toque contaba doble y el A/B
       habría medido el doble de uso del selector en los dos brazos. Se mide
       por tiempo y no por tagName para no perder la activación por teclado,
       que llega solo como clic en el radio. */
    var ultimoToque = 0;
    fieldset.addEventListener('click', function (ev) {
      var caja = ev.target.closest && ev.target.closest('.variant-input');
      if (!caja || !fieldset.contains(caja)) return;
      var ahora = Date.now();
      if (ahora - ultimoToque < 150) return;
      ultimoToque = ahora;
      var lista = visibles();
      var p = {
        pos: lista.indexOf(caja) + 1,
        colores: lista.length,
        foto: visibleFoto(),
        subio: false,
        enviado: false
      };
      p.timer = setTimeout(function () { mandar(p); }, ESPERA);
      pendientes.push(p);
    });

    /* Mientras haya toques sin mandar, cada scroll revisa si la foto llegó a
       verse entera (80 %): eso es «subió a mirar el resultado». */
    window.addEventListener('scroll', function () {
      if (!pendientes.length) return;
      if (visibleFoto() < 80) return;
      pendientes.forEach(function (p) { if (!p.enviado) p.subio = true; });
    }, { passive: true });

    function vaciar() { pendientes.forEach(mandar); pendientes = []; }
    window.addEventListener('pagehide', vaciar);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') vaciar();
    });

    if (seccion) seccion.setAttribute('data-bb-medir-color', '');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
